// Tonal placeholder for products without a photo. Ported verbatim from kioskv2
// (lib/screens/main/menu/widgets/product_image.dart → toneIndexFor) so the
// no-image tile matches the kiosk: a quiet pastel fill keyed off the product
// name, with a dish glyph tinted one shade deeper (`ink`).
export const PRODUCT_TONES = [
  { bg: '#F2E6D8', ink: '#DDCFBC' }, // 0 sand
  { bg: '#E8E2D5', ink: '#D4CBB9' }, // 1 oat
  { bg: '#E5E9E0', ink: '#CCD4C5' }, // 2 sage
  { bg: '#E0E6EC', ink: '#C2CCD6' }, // 3 mist
  { bg: '#ECE4E6', ink: '#D8C9CD' }, // 4 blush
  { bg: '#EAE6EE', ink: '#CDC4D7' }, // 5 lilac
];

// djb2-style string hash truncated to a 32-bit signed int, mapped to 0..5.
// `| 0` mirrors the kiosk's `& 0xFFFFFFFF` + `toSigned(32)`, so the same
// product name picks the same tone here and in the Flutter kiosk.
export const toneIndexFor = (name = '') => {
  let h = 0;
  for (let i = 0; i < name.length; i += 1) {
    h = ((h << 5) - h + name.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % PRODUCT_TONES.length;
};

export const productTone = (name = '') => PRODUCT_TONES[toneIndexFor(name)];
